<script setup>

</script>

<template>
  <section>
    <div class="table responsive">
      <table class="table table-sm text-xs table-bordered">
        <tbody>
          <tr>
            <th colspan="3"><u>Upfront Income</u></th>
          </tr>
          <tr>
            <td>Opening Fee</td>
            <td width="100">$</td>
            <td width="100">%</td>
          </tr>
          <tr>
            <td colspan="3" class="py-3 bg-white"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<style scoped>
td,
th,
thead {
  text-align: left;
}
</style>
